import { z } from 'zod'

// URL validation schema
export const urlSchema = z
  .string()
  .min(1, 'URL is required')
  .url('Please enter a valid URL (must start with http:// or https://)')
  .refine(
    (url) => {
      try {
        const urlObj = new URL(url)
        return urlObj.protocol === 'http:' || urlObj.protocol === 'https:'
      } catch {
        return false
      }
    },
    {
      message: 'URL must start with http:// or https://',
    }
  )

// WCAG Level validation
export const wcagLevelSchema = z.enum(['wcag2a', 'wcag2aa', 'wcag2aaa'], {
  errorMap: () => ({ message: 'Invalid WCAG level. Must be wcag2a, wcag2aa, or wcag2aaa' }),
})

// Scan form schema
export const scanFormSchema = z.object({
  url: urlSchema,
  wcagLevel: wcagLevelSchema.default('wcag2aa'),
  scanType: z.enum(['single', 'multi']).default('single'),
  websiteConnectionId: z.string().optional(),
})

// WordPress connection schema
export const wordPressConnectionSchema = z.object({
  siteUrl: z
    .string()
    .min(1, 'WordPress site URL is required')
    .url('Please enter a valid WordPress site URL')
    .refine(
      (url) => {
        try {
          const urlObj = new URL(url)
          return urlObj.protocol === 'https:'
        } catch {
          return false
        }
      },
      {
        message: 'WordPress site URL must use HTTPS',
      }
    ),
  apiKey: z
    .string()
    .min(1, 'API key is required')
    .startsWith('ada_', 'API key must start with "ada_"'),
})

// WordPress scan page schema
export const wordPressScanPageSchema = z.object({
  siteUrl: z.string().url(),
  apiKey: z.string().min(1),
  pageId: z.number().positive('Page ID must be a positive number'),
  wcagLevel: wcagLevelSchema.default('wcag2aa'),
})

// WordPress apply fixes schema
export const wordPressApplyFixesSchema = z.object({
  siteUrl: z.string().url(),
  apiKey: z.string().min(1),
  pageUrl: z.string().url(),
  fixes: z.array(z.any()).min(1, 'At least one fix is required'),
})
